<template>
  <div class="i-user-multi-picker">
    <i-multi-picker
      ref="MultiPicker"
      :label-counter="resolvedLabelCounter"
      :label="resolvedLabel"
      :placeholder="resolvedPlaceholder"
      :value="value"
      :fetch-options="fetchObjects"
      option-label="displayName"
      option-value="id"
      :disabled="isLoading || disabled"
      @input="$val => $emit('input',$val)"
    />

    <i-loader v-if="isLoading" :is-loading="isLoading"/>

    <span v-if="disabled" class="error-msg">{{ $t('recovery.comparesPage.selectSnapshotDatesFirst') }}</span>
  </div>
</template>

<script>
import IMultiPicker from "@/components/common/forms/IMultiPicker";
import {fetchObjectsMultiPicker} from "@/utils/fetchObjectsMultiPicker";
import ILoader from "@/components/common/ILoader.vue";

export default {
  name: 'IObjectMultiPicker',
  components: {ILoader, IMultiPicker},
  props: {
    value: [],
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    snapshotDateTime: {
      type: String
    },
    objectType: {
      type: [String, Number],
      default: null,
      required: false
    },
    snapshotId: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    resolvedLabel() {
      return this.label || this.$t('recovery.objectsPage.compareBox.objects');
    },
    resolvedPlaceholder() {
      return this.placeholder || this.$t('recovery.objectsPage.compareBox.searchAllObjects');
    },
    resolvedLabelCounter() {
      return this.$t('recovery.objectsPage.compareBox.objectCount');
    }
  },

  data() {
    return {
      selected: null,
      objects: [],
      isLoading: false,
      debounceTimer: null,
      hasLoadedOnce: false
    }
  },

  methods: {
    fetchObjects({search}) {
      if (this.disabled) {
        return Promise.resolve([]);
      }

      return new Promise((resolve, reject) => {
        if (this.debounceTimer) clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {

          if (this.disabled) {
            this.isLoading = false;
            resolve([]);
            return;
          }

          if (!this.hasLoadedOnce) {
            this.isLoading = true;
          }

          this.objectsFetcher({
            search: search,
            objectType: this.objectType,
            snapshotDateTime: this.snapshotDateTime,
            snapshotId: this.snapshotId
          })
            .then(({result}) => {
              this.isLoading = false;
              this.hasLoadedOnce = true;
              resolve(result);
            })
            .catch(err => {
              this.isLoading = false;
              this.hasLoadedOnce = true;
              reject(err);
            });
        }, 500);
      });
    }
  },
  created() {
    this.objectsFetcher = fetchObjectsMultiPicker(this.$providerTenant);
  },
  watch: {
    snapshotId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.snapshotId = newVal;
        this.hasLoadedOnce = false;
        this.$refs.MultiPicker.onSearch(null);
      }
    },
    disabled(isDisabled) {
      if (!isDisabled) {
        this.hasLoadedOnce = false;

        this.$nextTick(() => {
          if (this.$refs.MultiPicker) {
            this.$refs.MultiPicker.onSearch(null);
          }
        });
      }
    }
  }
}
</script>

<style lang="scss">
@import "IUserMultiPicker.scss";
</style>
